import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

// Importation de tes pages
import Home from './pages/Home/Home';
import Rules from './pages/Rules/Rules';
import Registration from './pages/Registration/Registration';
import Game from './pages/Game/Game';
import Controller from './pages/Controller/Controller';

// Importation de ton style global
import './styles/global.scss';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Définition des "chemins" de ton application */}
        <Route path="/" element={<Home />} />
        <Route path="/rules" element={<Rules />} />
        
        <Route path="/inscription" element={<Registration />} />
        <Route path="/inscription/:codePartie" element={<Registration />} />
        
        <Route path="/game" element={<Game />} />
        <Route path="/game/:codePartie" element={<Game />} />
        
        <Route path="/controller" element={<Controller />} />
        <Route path="/controller/:codePartie" element={<Controller />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;